declare var Pusher: any;

export interface IPusherConfig {
  key: string;
  cluster: string;
}
export class PusherService {
  private pusher: any;
  private pusherChannel: any;
  private subscribed: boolean = false;

  // pusher.disconnect();
  // Note: connections automatically close when a user navigates to another web page or closes their web browser so there is no need to do this manually.

  // NOTE: Channel name is limited to 164 characters
  // channelName for our app is the users email and has to be subscribed once per app session - So its done in header.js
  configure(config: IPusherConfig) {
    if (!config.key) {
      console.warn('Pusher key is missing');
    }
    this.pusher = new Pusher(config.key, {
      cluster: config.cluster || 'mt1',
      encrypted: true
    });
    return this;
  }
  startChannel(channelName: string, config?: IPusherConfig) {
    if (_.isEmpty(channelName)) {
      console.warn('Unable to start Pusher channel as channel name is not set');
      return;
    }
    // Prevent creating multiple pusher channels
    if (!this.pusher && config) {
      this.configure(config);
    }
    if (!this.pusher) {
      console.warn('No pusher initiated, configure first');
      return;
    }
    if (!this.pusherChannel) {
      this.pusherChannel = this.pusher.subscribe(channelName);
    }
    if (this.pusherChannel.name !== channelName) {
      this.pusherChannel = undefined;
      this.pusherChannel = this.pusher.subscribe(channelName);
    }
    this.waitForSubScription(channelName, () => {
      this.subscribed = true;
    });
  }

  waitForSubScription(channelName: string, callback: () => void) {
    if (this.subscribed) {
      callback();
    } else {
      this.bindToPusherEvent(channelName, 'pusher:subscription_succeeded', callback, true);
    }
  }

  // tslint:disable-next-line: bool-param-default
  bindToPusherEvent(
    channelName: string,
    listeningEvent: string,
    callbackFunction: () => void,
    preventUnbind?: boolean
  ) {
    if (!!this.pusherChannel) {
      if (!preventUnbind) {
        this.pusherChannel.unbind(listeningEvent); // unbind any previous callbacks to maintain single callback.
      }
      this.pusherChannel.bind(listeningEvent, callbackFunction);
    }
  }

  unBindToPusherEvent(channelName: string, listeningEvent: string, callbackFunction: () => void) {
    if (!!this.pusherChannel) {
      this.pusherChannel.unbind(listeningEvent, callbackFunction);
    }
  }

  // Fallback method for old code
  startPusherChannel(channelName: string, listeningEvent: string, callbackFunction: () => void) {
    // Prevent multiple bindings to same channel every time we click register or drop course buttons
    this.unBindToPusherEvent(channelName, listeningEvent, callbackFunction);
    this.bindToPusherEvent(channelName, listeningEvent, callbackFunction);
  }
}



// WEBPACK FOOTER //
// ./app/lib/global/servants/pusher_service.ts